/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Content_Section_1_HeadingInputs */

const en_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dissipation of force`)
};

const es_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disipación de la fuerza`)
};

const de_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraftverteilung`)
};

const zh_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`力量消散`)
};

const ar_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبديد القوة`)
};

const fr_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dissipation des forces`)
};

const vi_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân tán lực`)
};

const sw_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usambazaji wa nguvu`)
};

const th_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การกระจายแรง`)
};

const bs_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disipacija sile`)
};

const ja_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`力の分散`)
};

const ko_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`힘의 분산`)
};

const pt_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dissipação da força`)
};

const it_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dissipazione della forza`)
};

const sv_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraftspridning`)
};

const nl_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krachtverdeling`)
};

const da_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraftfordeling`)
};

const nb_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraftfordeling`)
};

const fi_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voiman hajauttaminen`)
};

const pl_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpraszanie siły`)
};

const ru_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рассеивание силы`)
};

const tr_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuvvetin dağıtılması`)
};

const hi_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बल का वितरण`)
};

const id_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyebaran gaya`)
};

const ms_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyebaran daya`)
};

const cs_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozptyl síly`)
};

const el_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διάχυση της δύναμης`)
};

const he_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פיזור כוח`)
};

const af_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verspreiding van krag`)
};

const hu_injury_content_section_1_heading = /** @type {(inputs: Injury_Content_Section_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az erő eloszlása`)
};

/**
* | output |
* | --- |
* | "Dissipation of force" |
*
* @param {Injury_Content_Section_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_content_section_1_heading = /** @type {((inputs?: Injury_Content_Section_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Content_Section_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_content_section_1_heading(inputs)
	if (locale === "de") return de_injury_content_section_1_heading(inputs)
	if (locale === "zh") return zh_injury_content_section_1_heading(inputs)
	if (locale === "ar") return ar_injury_content_section_1_heading(inputs)
	if (locale === "fr") return fr_injury_content_section_1_heading(inputs)
	if (locale === "vi") return vi_injury_content_section_1_heading(inputs)
	if (locale === "sw") return sw_injury_content_section_1_heading(inputs)
	if (locale === "th") return th_injury_content_section_1_heading(inputs)
	if (locale === "bs") return bs_injury_content_section_1_heading(inputs)
	if (locale === "ja") return ja_injury_content_section_1_heading(inputs)
	if (locale === "ko") return ko_injury_content_section_1_heading(inputs)
	if (locale === "pt") return pt_injury_content_section_1_heading(inputs)
	if (locale === "it") return it_injury_content_section_1_heading(inputs)
	if (locale === "sv") return sv_injury_content_section_1_heading(inputs)
	if (locale === "nl") return nl_injury_content_section_1_heading(inputs)
	if (locale === "da") return da_injury_content_section_1_heading(inputs)
	if (locale === "nb") return nb_injury_content_section_1_heading(inputs)
	if (locale === "fi") return fi_injury_content_section_1_heading(inputs)
	if (locale === "pl") return pl_injury_content_section_1_heading(inputs)
	if (locale === "ru") return ru_injury_content_section_1_heading(inputs)
	if (locale === "tr") return tr_injury_content_section_1_heading(inputs)
	if (locale === "hi") return hi_injury_content_section_1_heading(inputs)
	if (locale === "id") return id_injury_content_section_1_heading(inputs)
	if (locale === "ms") return ms_injury_content_section_1_heading(inputs)
	if (locale === "cs") return cs_injury_content_section_1_heading(inputs)
	if (locale === "el") return el_injury_content_section_1_heading(inputs)
	if (locale === "he") return he_injury_content_section_1_heading(inputs)
	if (locale === "af") return af_injury_content_section_1_heading(inputs)
	if (locale === "hu") return hu_injury_content_section_1_heading(inputs)
	return en_injury_content_section_1_heading(inputs)
});